<template>
	<div class="product-add">
		<!--form表单-->
		<el-form size="small" ref="form" :model="form" label-width="180px">
			<el-tabs v-model="activeName">
				<el-tab-pane label="基础设置" name="basic"></el-tab-pane>
				<!-- <el-tab-pane label="加钟项目" name="clockProduct"></el-tab-pane> -->
				<el-tab-pane label="项目描述" name="content"></el-tab-pane>
				<el-tab-pane label="禁忌说明" name="spec"></el-tab-pane>
				<el-tab-pane label="下单说明" name="buyset"></el-tab-pane>
			</el-tabs>
			<!--基础信息-->
			<!--基础信息-->
			<Basic v-show="activeName == 'basic'"></Basic>
			<!--禁忌说明-->
			<Spec v-show="activeName == 'spec'"></Spec>
			<!--项目描述-->
			<Content v-show="activeName == 'content'"></Content>
			<!--下单说明-->
			<Buyset v-show="activeName == 'buyset'"></Buyset>
			<clockProduct v-show="activeName == 'clockProduct'"></clockProduct>
			<!--提交-->
			<div class="common-button-wrapper">
				<el-button size="small" type="info" @click="cancelFunc">取消</el-button>
				<el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>
				<!-- <el-button size="small" type="primary" @click="Draft" :loading="loading">保存为草稿</el-button> -->
			</div>
		</el-form>
	</div>
</template>

<script>
	import PorductApi from "@/api/product.js";
	import Basic from "./part/Basic.vue";
	import Spec from "./part/Spec.vue";
	import Content from "./part/Content.vue";
	import Buyset from "./part/Buyset.vue";
	import clockProduct from "./part/clockProduct.vue";
	export default {
		components: {
			/*基础信息*/
			Basic,
			/*规格信息*/
			Spec,
			/*商品详情*/
			Content,
			/*高级设置*/
			Buyset,
			clockProduct
		},
		data() {
			return {
				activeName: "basic",
				/*是否正在加载*/
				loading: false,
				/*form表单数据*/
				form: {
					model: {
						tag: [],
						productClock: [{
							productName: null,
							imageId: 0,
							productPrice: null,
							serviceTime: null,
							salesInitial: null,
							productSort: 0,
							image: {
								filePath: null

							}

						}],
						serviceCategory: null,
						imageId: 0,
						isClock: 0,
						serviceId: null,
						shopSupplierId: 0,
						/*商品名称*/
						productName: null,
						/*商品分类*/
						categoryId: null,
						/*商品图片*/
						image: [],
						detailimg: [],
						isPicture: 0,
						/*商品卖点*/
						sellingPoint: null,
						/*规格类别,默认10单规格，20多规格*/
						specType: 10,
						/*库存计算方式,默认20付款减库存，10下单减库存*/
						deductStockType: 20,
						/*检查用户等级*/
						isAloneGrade: 0,
						sku: {
							productNo: 0,
							productPrice: null,
							linePrice: 0,
							stockNum: 0
						},
						serviceTime: null,
						/*多规格类别*/
						// spec_many: {
						// 	/*多规格类别*/
						// 	spec_attr: [],
						// 	/*多规格表格数据*/
						// 	spec_list: []
						// },
						/*商品详情内容*/
						content: null,
						tabooContent: null,
						orderContent: null,
						/*运费模板ID*/
						deliveryId: null,
						/*商品状态*/
						productStatus: 10,
						/*初始销量*/
						salesInitial: 0,
						/*商品排序，默认100*/
						productSort: 100,
						salesInitial: 0,
						/*是否开启积分赠送,默认1为开启，0为关闭*/
						isPointsGift: 1,
						/*是否允许使用积分抵扣,默认1为允许，0为不允许*/
						isPointsDiscount: 1,
						/*最大积分抵扣数量*/
						maxPointsDiscount: 0,
						/*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
						isEnableGrade: 1,
						/*等级金额类型,默认10为百分比，20为固定金额*/
						aloneGradeType: 10,
						/*限购会员*/
						gradeIds: [],
						/*是否开启单独分销,默认0为关闭，1为开启*/
						isIndAgent: 0,
						/*分销佣金类型,默认10为百分比，20为固定金额*/
						agentMoneyType: 10,
						/*一级佣金*/
						firstMoney: 0,
						/*二级佣金*/
						secondMoney: 0,
						/*三级佣金*/
						thirdMoney: 0,
						/*是否虚拟商品*/
						isVirtual: 0,
						/*限购数量*/
						limitNum: 0,
						/*虚拟商品发货方式*/
						virtualAuto: 0,
						/*虚拟商品发货内容*/
						virtualContent: null
					},
					/*商品分类*/
					category: [],
					serviceList: [],
					supplierList: [],
					/*运费模板*/
					delivery: [],
					/*会员等级*/
					gradeList: [],
					/*规格数据*/
					specData: null,
					/*是否锁住*/
					isSpecLocked: false,
					// 简介
					intro: ''
				}
			};
		},
		provide: function() {
			return {
				form: this.form
			};
		},
		created() {
			/*获取基础数据*/
			this.getBaseData();
		},
		methods: {
			/*获取基础数据*/
			getBaseData: function() {
				let self = this;
				PorductApi.getBaseData({}, true)
					.then(res => {
						self.loading = false;
						console.log(res.data,"商品数据")
						Object.assign(self.form, res.data);
						console.log(res.data, "data");
					})
					.catch(error => {
						self.loading = false;
					});
			},

			/*转JSON字符串*/
			convertJson(list) {
				let obj = {};
				list.forEach(item => {
					obj[item.grade_id] = item.product_equity;
				});
				return JSON.stringify(obj);
			},

			/*提交*/
			onSubmit: function() {
				let self = this;
				let params = self.form.model;
				if(params.content==null){
					self.$message({
					  message: "请填写项目描述",
					  type: "error"
					});
					return;
				}
				// if (self.form.model.tag != null && self.form.model.tag.length) {
				// 	params.tag = self.form.model.tag.join(",");
				// }
				// console.log(params)
				self.$refs.form.validate(valid => {
					
				  if (valid) {
				    self.loading = true;
				    params.aloneGradeEquity = self.convertJson(self.form.gradeList);
				    PorductApi.addProduct(
				      {
				        params: JSON.stringify(params)
				      },
				      true
				    )
				      .then(data => {
				        self.loading = false;
				        self.$message({
				          message: "添加成功",
				          type: "success"
				        });
				        self.$router.push("/product/product/index");
				      })
				      .catch(error => {
				        self.loading = false;
				      });
				  } else {
				    self.$message({
				      message: "请检查必填项是否填写完整",
				      type: "error"
				    });
				  }
				});
			},

			/*保存为草稿*/
			Draft() {
				let self = this;
				self.form.model.productStatus = 30;
				self.onSubmit();
			},

			/*取消*/
			cancelFunc() {
				this.$router.back(-1);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.basic-setting-content {}

	.product-add {
		padding-bottom: 100px;
	}
</style>


// WEBPACK FOOTER //
// src/views/product/product/add.vue